import React from "react";

// plugin imports
import axios from "axios";

// utils imports

// svg imports
const defaultValues = {
	fetchCarta: () => {},
	menusData: undefined,
	menuError: false,
};

export const MenuDataContext = React.createContext(defaultValues);

export const MenuDataProvider = ({ children }) => {
	const [menusData, setMenusData] = React.useState(undefined);
	const [pricesData, setPricesData] = React.useState(undefined);
	const [fetchError, setFetchError] = React.useState(false);

	const initiatedRequests = React.useRef(new Set());

	const fetchCarta = async (restaurant) => {
		const restaurantId = restaurant.fields.id;

		const csvToState = (response, setState = () => {}, sheetName) => {
			const valuesArray = [];

			const values = response.data.values;

			for (var i = 1; i < values.length; i++) {
				// we start at i = 1 cause i = 0 are headers

				var row = {}; // Create a new row object for each row
				for (var j = 0; j < 100; j++) {
					if (values[i][j] === undefined || values[i][j] === "FALSE") {
						break;
					}
					row[values[0][j]] = values[i][j];
				}
				if (Object.keys(row).length > 0) valuesArray.push(row); // Push the row to the output array as object
			}

			if (sheetName === "menu") {
				const categoryOrder = [];
				valuesArray.forEach((row) => {
					if (row.category && !categoryOrder.includes(row.category)) {
						categoryOrder.push(row.category);
					}
				});
				valuesArray.sort((a, b) => {
					const indexA = categoryOrder.indexOf(a.category);
					const indexB = categoryOrder.indexOf(b.category);
					return indexA - indexB;
				});
			}

			setState((prevState) => ({
				...prevState,
				[restaurantId]: valuesArray,
			}));
		};

		const fetchCsv = (sheetName, stateData, setStateData) => {
			const key = `${restaurantId}_${sheetName}`;
			if (
				initiatedRequests.current.has(key) ||
				(stateData && Object.keys(stateData).includes(restaurantId))
			) {
				return;
			} else {
				initiatedRequests.current.add(key);
				axios
					.get(`https://cdn-kaisushi.telita.es/data/${key}.json`)
					.then((response) => {
						// response.data.products.forEach(
						// 	(product) => product.type === "Menu" && console.log(product)
						// );
						csvToState(response, setStateData, sheetName);
					})
					.catch((error) => {
						initiatedRequests.current.delete(key);
						console.error("Error fetching csv:", sheetName, error);
						setFetchError(error);
						// If error, use vlc-russafa data instead
						axios
							.get(
								`https://cdn-kaisushi.telita.es/data/vlc-russafa_${sheetName}.json`,
							)
							.then((response) => {
								// response.data.products.forEach(
								// 	(product) => product.type === "Menu" && console.log(product)
								// );
								csvToState(response, setStateData, sheetName);
							})
							.catch((error) => {
								initiatedRequests.current.delete(key);
								console.error("Error fetching csv:", sheetName, error);
								setFetchError(error);
							});
					});
			}
		};

		const fetchAllMenus = () => {
			fetchCsv("prices", pricesData, setPricesData);
			fetchCsv("menu", menusData, setMenusData);
		};

		fetchAllMenus();
	};

	return (
		<MenuDataContext.Provider
			value={{
				...defaultValues,
				fetchCarta,
				menusData,
				pricesData,
				fetchError,
			}}
		>
			{children}
		</MenuDataContext.Provider>
	);
};
